import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-boolean-on-large.tsx
/**
* icon.24.boolean.on.large
*
* Attention, warning, exclamation mark
*
* Keywords: eye, view, visibility, watch, preview, show, observe, reveal
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE1IDZhNiA2IDAgMCAxIDAgMTJIOUE2IDYgMCAwIDEgOSA2ek05IDdhNSA1IDAgMCAwIDAgMTBoNmE1IDUgMCAwIDAgMC0xMHptNiAxLjVhMy41IDMuNSAwIDEgMSAwIDcgMy41IDMuNSAwIDAgMSAwLTdtMCAxYTIuNSAyLjUgMCAxIDAgMCA1IDIuNSAyLjUgMCAwIDAgMC01Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58736
*/
const Icon24BooleanOnLarge = memo(function Icon24BooleanOnLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M15 6a6 6 0 0 1 0 12H9A6 6 0 0 1 9 6zM9 7a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 1.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
		})
	});
});
//#endregion
export { Icon24BooleanOnLarge };

//# sourceMappingURL=icon-24-boolean-on-large.js.map